import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CartModal = ({ isOpen, onClose, cart, getCartTotal, getCartCount, removeFromCart, initiateCartCheckout, paymentLoading, setPaymentLoading, setCart }) => {
  const { t } = useLanguage();
  const [promo, setPromo] = React.useState('');
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-xl border border-white/10 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            IL TUO CARRELLO ({getCartCount()} prodott{getCartCount() !== 1 ? 'i' : 'o'})
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors duration-150 text-xl"
          >
            ✕
          </button>
        </div>

        <div className="p-6">
          {cart.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-400">Il carrello è vuoto</p>
            </div>
          ) : (
            <>
              <div className="space-y-4 mb-6">
                {cart.map((item, index) => (
                  <div key={`cart-modal-${index}`} className="bg-gray-800/50 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="text-white font-medium text-sm">{item.name}</h4>
                      <button
                        onClick={() => removeFromCart(item.id, item.line_color)}
                        className="text-red-400 hover:text-red-300 text-lg"
                      >
                        ✕
                      </button>
                    </div>
                    <p className="text-gray-400 text-xs mb-2">{item.line_color_name || `Linea ${item.line_color}`}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-white text-sm">Qtà: {item.quantity}</span>
                      <span className="text-white font-bold">€{(item.price * item.quantity).toFixed(2)}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-t border-white/10 pt-4 space-y-3">
                <div className="flex justify-between text-gray-400">
                  <span>{t('cart.subtotal')}</span>
                  <span>€{getCartTotal().toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-gray-400">
                  <span>{t('cart.shipping')}</span>
                  <span className="text-emerald-300 font-semibold" data-testid="cart-modal-shipping">{t('cart.free_shipping')}</span>
                </div>
                <div className="flex justify-between text-white font-bold text-lg border-t border-white/10 pt-3">
                  <span>{t('cart.total')}</span>
                  <span data-testid="cart-modal-total">€{getCartTotal().toFixed(2)}</span>
                </div>
              </div>

              <div className="mt-6 space-y-3">
                <div>
                  <label className="block text-gray-400 text-xs mb-1.5 uppercase tracking-wider" htmlFor="promo-code">{t('cart.promo_label')}</label>
                  <input
                    id="promo-code"
                    type="text"
                    value={promo}
                    onChange={(e) => setPromo(e.target.value)}
                    placeholder={t('cart.promo_placeholder')}
                    data-testid="cart-promo-input"
                    className="w-full bg-gray-800/60 border border-white/15 rounded-lg px-4 py-2.5 text-white text-sm outline-none focus:border-pink-500 transition-colors duration-150"
                  />
                </div>
                <button
                  data-testid="cart-checkout-button"
                  disabled={paymentLoading}
                  onClick={() => {
                    onClose();
                    initiateCartCheckout(promo.trim());
                  }}
                  className="w-full bg-pink-600 text-white py-4 px-6 rounded-lg font-bold text-lg hover:bg-pink-700 transition-all duration-150 disabled:opacity-50"
                >
                  {paymentLoading ? t('cart.processing') : t('cart.proceed')}
                </button>

                <button
                  onClick={() => {
                    setCart([]);
                    onClose();
                  }}
                  className="w-full text-red-400 hover:text-red-300 text-sm py-2"
                  data-testid="cart-clear-button"
                >
                  Svuota carrello
                </button>
              </div>

              <p className="text-center text-gray-500 text-xs mt-4">
                Pagamento sicuro tramite Stripe - Spedizione in 2-3 giorni lavorativi
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartModal;
